import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import vodAdapter from 'shared/utils/adapters/vod';

const ACTIONS = createAsyncActions('SERVER.VOD-SETTINGS.GET');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


export default function () {
  return function (dispatch) {
    dispatch(START());

    return vodAdapter.settings.get()
      .then(
        function (result) {
          dispatch(SUCCESS({}, result));
          return result;
        },

        function (reason) {
          dispatch(FAIL(null, null, { analytics: { type: 'error', payload: { name: 'shared.vod-settings.get' } } }));
          return Promise.reject(reason);
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/shared/redux/server/actions/vod-settings/get.js